export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // {
    //   name: 'dashboard',
    //   displayName: 'Dashboard',
    //   meta: {
    //     iconClass: 'vuestic-iconset-dashboard',
    //   },
    // },
    {
      name: 'utilisateur',
      displayName: 'Utilisateurs',
      meta: {
        iconClass: 'vuestic-iconset-user',
      },
      disabled: true,
      children: [
        {
          name: 'conducteurs',
          displayName: 'menu.conducteurs',
        },
        {
          name: 'passagers',
          displayName: 'menu.passagers',
        },
      ],
    },
    {
      name: 'trajet',
      displayName: 'Trajets',
      meta: {
        iconClass: 'entypo-direction',
      },
      disabled: true
    },

    {
      name: 'voyage',
      displayName: 'Voyages',
      meta: {
        iconClass: 'entypo-globe',
      }
    },

    {
      name: 'reservation',
      displayName: 'Réservations',
      meta: {
        iconClass: 'entypo-calendar',
      }
    },
    // {
    //   name: 'souscription',
    //   displayName: 'Souscriptions',
    //   meta: {
    //     iconClass: 'entypo-ticket',
    //   },
    //   children: [
    //     {
    //       name: 'index',
    //       displayName: 'Tous',
    //     },
    //     {
    //       name: 'expire',
    //       displayName: 'Expirées',
    //     },
    //     {
    //       name: 'active',
    //       displayName: 'Actives',
    //     },
    //   ],
    // },
    {
      name: 'listeVehicule',
      displayName: 'Véhicules',
      meta: {
        iconClass: 'entypo-gauge',
      }
    },
    {
      name: 'adresse',
      displayName: 'Adresses',
      meta: {
        iconClass: 'typicons-location',
      },
    },
    // {
    //   name: 'administrateur',
    //   displayName: 'Administrateurs',
    //   meta: {
    //     iconClass: 'entypo-user',
    //   }, 
    // },
    {
      name: 'parametre',
      displayName: 'Paramètres',
      meta: {
        iconClass: 'vuestic-iconset-settings',
      },
      children: [
        {
          name: 'configuration',
          displayName: 'menu.configuration',
        },
        {
          name: 'liste',
          displayName: 'menu.liste',
        },
        
      ], 
    },
    {
      name: 'offres',
      displayName: 'Offres',
      meta: {
        iconClass: 'entypo-box',
      },
    },
  ],
}
